import {useFormik} from "formik";
import Button from "../Button";
import Switch from "react-switch";
import React, {useContext, useState} from "react";
import {FaRegUser} from "react-icons/fa";
import bankClearanceValidation from "../../tools/validations/bankClearance/bankClearanceValidation";
import FinCheckContext from "../../tools/contexts/finCheck/FincheckContext";
import ChooseAddonType from "./ChooseAddonType";
import PLATFORMS from "../../tools/defaults/Platforms";

const InitConfirm = ({onConfirm}) => {
    const [nationalCodeMatchWithMobile, setNationalCodeMatchWithMobile] = useState(false);
    const finCheckContext = useContext(FinCheckContext);
    const handleSubmit = (values) => {


        if (rested) {
            onConfirm(values)
        } else {
            onConfirm({
                ...values,
                is_user_add_on: addonType === "userAddon"
            })
        }

    }
    const formik = useFormik({
        initialValues: {
            nationalId: finCheckContext?.process?.confirmed_data?.NationalId || '',
        },
        validationSchema: bankClearanceValidation,
        onSubmit: handleSubmit,
    });
    const handleChangeNationalId = (e) => {
        const value = e.target.value;
        const filteredValue = value.replace(/[^0-9۰-۹]/g, "");
        if (e.target.value.length <= 10) {
            formik.setFieldValue("nationalId", filteredValue);
        }
    }
    const handleNationalCodeMatchWithMobile = (isChecked) => {
        setNationalCodeMatchWithMobile(isChecked)
    };
    const showChooseAddon = !!finCheckContext?.process?.user_add_on_mode;
    const rested = finCheckContext?.process?.passed_steps?.includes(PLATFORMS.DIVAR.APPS.FIN_CHECK.STEPS.INIT_CONFIRM);

    const [addonType, setAddonType] = useState("postAddon");
    const [step, setStep] = useState(showChooseAddon ? rested ? "Form" : "ChooseAddon" : "Form");
    const handleChooseAddon = (addonType) => {
        setAddonType(addonType);
        setStep("Form");
    }
    if (step === "ChooseAddon" && finCheckContext.process && finCheckContext.pid) {
        return <ChooseAddonType addonType={addonType} onConfirm={handleChooseAddon}/>
    }
    const handleBackToChooseAddon = () => {
        setStep("ChooseAddon")
    }
    return <form className="p-5 bg-white flex-col rounded-lg" onSubmit={formik.handleSubmit}>
        <div className="w-full flex flex-col justify-center items-center border-b pb-3 mb-3">
            <div className="p-4 rounded-full  bg-gray-100">
                <FaRegUser className="text-2xl text-green-500"/>
            </div>
            <span className=" mt-2 font-semibold">
                        تکمیل اطلاعات
                    </span>
        </div>
        <div className="w-full flex mt-2 flex-col">
            <label className="text-sm" htmlFor="">شماره موبایل</label>
            <input
                dir="rtl"
                placeholder=""
                name="mobile"
                value={finCheckContext.process.platform_user}
                disabled
                className="bg-gray-200  text-sm border mt-1 px-4 py-3 rounded-lg"
            />
        </div>
        <div className="w-full flex mt-2 flex-col">
            <label className="text-sm" htmlFor="">کد ملی</label>
            <input
                dir="rtl"
                placeholder="کد ملی خود را وارد کنید."
                name="nationalId"
                value={formik.values.nationalId}
                onChange={handleChangeNationalId}
                type="tel"
                className="bg-gray-50  outline-none focus:border-green-500 border-gray-200 text-sm border mt-1 px-4 py-3 rounded-lg"
            />
            {formik.errors.nationalId && formik.touched.nationalId ? (
                <p className="text-red-400  mt-1 text-sm">{formik.errors.nationalId}</p>
            ) : null}
        </div>
        <div className="w-full mt-6   flex justify-between">
            <span className="text-sm">کد ملی با شماره موبایل مطابقت دارد.</span>
            <Switch onHandleColor="#fafafa" onColor="#36b570" onChange={handleNationalCodeMatchWithMobile} dir="rtl"
                    size={50} checkedIcon={false} uncheckedIcon={false}
                    height={20} width={40} checked={nationalCodeMatchWithMobile}/>
        </div>
        <div className={`grid ${(showChooseAddon && !rested) ? 'grid-cols-2' : 'grid-cols-1'}`}>
            {(showChooseAddon && !rested) && <Button
                type="button"
                onClick={handleBackToChooseAddon}
                theme="link"
                className="mt-4 w-full rounded-lg text-sm">بازگشت</Button>
            }
            <Button
                type="submit"
                disabled={!nationalCodeMatchWithMobile}
                theme="green"
                className="mt-4 w-full rounded-lg text-sm">ثبت و ادامه</Button>
        </div>
    </form>
}
export default InitConfirm;